// Lightweight client-side estimate of SMS segments. The backend is authoritative
// (see smsSegmentService.js); this is only for live UX feedback while typing.
const GSM7_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM7_EXTENDED = "^{}\\[~]|€";

function isGsm7(text: string): boolean {
  for (const ch of text) {
    if (!GSM7_BASIC.includes(ch) && !GSM7_EXTENDED.includes(ch)) return false;
  }
  return true;
}

export function estimateSegments(text: string): { encoding: "GSM7" | "UCS2"; chars: number; segments: number } {
  if (text.length === 0) return { encoding: "GSM7", chars: 0, segments: 0 };
  const gsm = isGsm7(text);
  if (gsm) {
    // extended chars count as 2 toward the GSM-7 budget
    let units = 0;
    for (const ch of text) units += GSM7_EXTENDED.includes(ch) ? 2 : 1;
    const segments = units <= 160 ? 1 : Math.ceil(units / 153);
    return { encoding: "GSM7", chars: text.length, segments };
  }
  const segments = text.length <= 70 ? 1 : Math.ceil(text.length / 67);
  return { encoding: "UCS2", chars: text.length, segments };
}

// Parse a free-form list of phone numbers from a textarea or uploaded file.
// Splits on newlines, commas, semicolons, spaces, and tabs; trims; dedupes.
export function parseNumbers(raw: string): string[] {
  const parts = raw
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  return [...new Set(parts)];
}
